import { EmployeeIdentificationType } from '@fora-monorepo/employer-my-pages-common/types';

const stringMapping = {
  [EmployeeIdentificationType.PersonalIdentityNumber]: 'Personnnummer',
  [EmployeeIdentificationType.CoOrdinationNumber]: 'Samordningsnummer',
};

export const getEmployeeIdTypeString = (id: EmployeeIdentificationType) => {
  return stringMapping[id];
};
